import React from "react";

import { type IconSize, getSizeForIcon } from "../icon/IconSizes";

export interface ComponentIconProps {
	icon?: string;
	iconSize?: IconSize;
}

export const ComponentIcon: React.FC<ComponentIconProps> = ({ icon, iconSize }) => {
	const size = getSizeForIcon(iconSize);
	const componentStyle = {
		width: size,
		height: size,
	};

	return <img alt="icon" className="block max-w-none" src={icon} style={componentStyle} />;
};
